var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "@uigovpe/components";
import { useEffect, useMemo, useState } from "react";
import { getAnswersByConsultationItem, } from "../../../apis/answers";
import { getApiErrorMessage } from "../../../apis/http";
var pieColors = [
    "#4B5563",
    "#2563EB",
    "#059669",
    "#F59E0B",
    "#EF4444",
    "#7C3AED",
];
var barColors = [
    "#8979FF",
    "#7C6CF2",
    "#6F5FE6",
    "#6253DA",
    "#5547CF",
    "#483CC3",
    "#3C31B8",
    "#3027AD",
];
var cardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    display: "grid",
    gap: 24,
    padding: 24,
};
var feedbackCardStyle = __assign(__assign({}, cardStyle), { gap: 8 });
var answersListStyle = {
    display: "grid",
    gap: 12,
    maxHeight: 544,
    overflowY: "auto",
    paddingLeft: 16,
};
var textAnswerStyle = {
    background: "#F9FAFB",
    borderRadius: 8,
    padding: 16,
};
var chartCardStyle = {
    background: "#F9FAFB",
    borderRadius: 8,
    display: "grid",
    gap: 16,
    padding: 16,
};
var progressTrackStyle = {
    background: "#E5E7EB",
    borderRadius: 999,
    height: 10,
    overflow: "hidden",
    width: "100%",
};
var getCountsForItem = function (item, answers) {
    var counts = new Map();
    answers.forEach(function (answer) {
        var _a;
        if (item.type === "text") {
            return;
        }
        var values = item.type === "select_unique"
            ? ((_a = answer.jsonValue) === null || _a === void 0 ? void 0 : _a.slice(0, 1)) || []
            : answer.jsonValue || [];
        values.forEach(function (value) {
            counts.set(value, (counts.get(value) || 0) + 1);
        });
    });
    return (item.consultationItemOptions || []).map(function (option) { return ({
        label: option.label,
        total: counts.get(option.value) || 0,
        value: option.value,
    }); });
};
export var ResponsesSummary = function (_a) {
    var accessToken = _a.accessToken, items = _a.items;
    var _b = useState({}), answersByItem = _b[0], setAnswersByItem = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var isMounted = true;
        var loadAnswers = function () { return __awaiter(void 0, void 0, void 0, function () {
            var entries, loadError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!accessToken || items.length === 0) {
                            setAnswersByItem({});
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(items.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                                var answers;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, getAnswersByConsultationItem(item.id, accessToken)];
                                        case 1:
                                            answers = _a.sent();
                                            return [2 /*return*/, [item.id, answers]];
                                    }
                                });
                            }); }))];
                    case 2:
                        entries = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setAnswersByItem(entries.reduce(function (accumulator, _a) {
                            var itemId = _a[0], answers = _a[1];
                            accumulator[itemId] = answers;
                            return accumulator;
                        }, {}));
                        return [3 /*break*/, 5];
                    case 3:
                        loadError_1 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_1));
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadAnswers();
        return function () {
            isMounted = false;
        };
    }, [accessToken, items]);
    var hasAnyAnswer = useMemo(function () {
        return Object.values(answersByItem).some(function (entry) { return Array.isArray(entry) && entry.length > 0; });
    }, [answersByItem]);
    if (!accessToken) {
        return (_jsx("div", __assign({ style: feedbackCardStyle }, { children: _jsx(Typography, { children: "Fa\u00E7a login para visualizar o consolidado das respostas desta consulta." }) })));
    }
    if (loading) {
        return (_jsx("div", __assign({ style: feedbackCardStyle }, { children: _jsx(Typography, { children: "Carregando respostas..." }) })));
    }
    if (error) {
        return (_jsx("div", __assign({ style: feedbackCardStyle }, { children: _jsx(Typography, __assign({ style: { color: "#B91C1C" } }, { children: error })) })));
    }
    return (_jsxs("div", __assign({ style: { display: "grid", gap: 32 } }, { children: [items.map(function (item) {
                var answers = answersByItem[item.id] || [];
                var counts = getCountsForItem(item, answers);
                var maxCount = Math.max.apply(Math, __spreadArray([1], counts.map(function (entry) { return entry.total; }), false));
                return (_jsxs("div", __assign({ style: cardStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "bold" }, { children: [item.order, ". ", item.description] })), _jsx("div", __assign({ style: answersListStyle }, { children: item.type === "text" ? (_jsxs(_Fragment, { children: [answers.length === 0 ? (_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Nenhuma resposta textual ainda." }))) : null, answers.map(function (answer) { return (_jsx("div", __assign({ style: textAnswerStyle }, { children: _jsx(Typography, { children: answer.value || "" }) }), answer.id)); })] })) : (_jsxs("div", __assign({ style: chartCardStyle }, { children: [counts.map(function (entry, entryIndex) {
                                        var color = item.type === "select_unique"
                                            ? pieColors[entryIndex % pieColors.length]
                                            : barColors[entryIndex % barColors.length];
                                        return (_jsxs("div", __assign({ style: { display: "grid", gap: 8, width: "100%" } }, { children: [_jsxs("div", __assign({ style: {
                                                        alignItems: "center",
                                                        display: "flex",
                                                        gap: 12,
                                                        justifyContent: "space-between",
                                                    } }, { children: [_jsxs("div", __assign({ style: {
                                                                alignItems: "center",
                                                                display: "flex",
                                                                gap: 8,
                                                                minWidth: 0,
                                                            } }, { children: [_jsx("span", { style: {
                                                                        background: color,
                                                                        borderRadius: 999,
                                                                        display: "inline-block",
                                                                        height: 10,
                                                                        width: 10,
                                                                    } }), _jsx(Typography, __assign({ size: "sm" }, { children: entry.label }))] })), _jsx(Typography, __assign({ size: "sm" }, { children: entry.total }))] })), _jsx("div", __assign({ style: progressTrackStyle }, { children: _jsx("div", { style: {
                                                            background: color,
                                                            borderRadius: 999,
                                                            height: "100%",
                                                            width: "".concat((entry.total / maxCount) * 100, "%"),
                                                        } }) }))] }), entry.value));
                                    }), answers.length === 0 ? (_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Nenhuma sele\u00E7\u00E3o ainda." }))) : null] }))) }))] }), item.id));
            }), !hasAnyAnswer ? (_jsx("div", __assign({ style: feedbackCardStyle }, { children: _jsx(Typography, __assign({ style: { color: "#6B7280" } }, { children: "Nenhuma resposta ainda." })) }))) : null] })));
};
